import AuthMixin from '@/components/mixins/auth-mixin'

export default {
  name: 'cookieList',
  components: {},
  props: {
    dataProp: {
      type: String,
      default () { return '' }
    }
  },
  watch: {},
  mixins: [AuthMixin],
  data () {
    return {}
  },
  methods: {},
  mounted () {
    this.isAuthenticated();
    // Force re-load of Usercentrics embeddings data
    const ucCmp = window?.__ucCmp;
    try {
      if (ucCmp) {
        ucCmp.hydrateEmbeddings();
      }
    } catch (e) {
      console.error('Error loading Usercentrics embeddings data:', e);
    }
  }
}
